import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PruTableSortTypeEnum } from 'src/app/common/components/PruTable/PruTable';
import { LmBatchFileListItem } from 'src/app/modules/OpmPd/types/opm-pd-lm-types';
import { fetchLmBatchFiles, FetchLmBatchFilesParams } from 'src/app/modules/OpmPd/network/opm-pd-lm';

const initialState: FetchLmBatchFilesParams = {
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): FetchLmBatchFilesParams => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
        ...initialParams,
      }
    : initialState;
};

export const useLmBatchFilePruTable = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<FetchLmBatchFilesParams>(paramsInitiator(initialParams));
  const [lmBatchFiles, setLmBatchFiles] = useState<PaginateList<LmBatchFileListItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<LmBatchFileListItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchLmBatchFiles(filterState, dispatch);
      } catch (err) {}
    },
    setLmBatchFiles,
    false,
  );

  const onSort = (newSortState: { key: string; value?: string }) => {
    const { key, value } = newSortState;
    if (value) {
      let newSort = '';
      switch (value) {
        case PruTableSortTypeEnum.ASC:
          newSort = key;
          break;
        case PruTableSortTypeEnum.DESC:
          newSort = `-${key}`;
          break;
      }
      setFilterState({ ...filterState, sort: newSort });
    } else {
      setFilterState({ ...filterState, sort: undefined });
    }
    refreshData();
  };

  return {
    filterState,
    lmBatchFiles,
    isLoading,
    setFilterState,
    refreshData,
    onSort,
  };
};
